import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

const PrivacyPage = () => {
    return (
        <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto bg-white shadow rounded-lg p-8">
                <div className="flex items-center mb-6">
                    <Link to="/" className="mr-4 text-gray-500 hover:text-gray-700">
                        <ArrowLeftIcon className="h-6 w-6" />
                    </Link>
                    <h1 className="text-2xl font-bold text-gray-900">プライバシーポリシー</h1>
                </div>
                <div className="prose prose-blue max-w-none">
                    <p>byters（以下，「当社」といいます。）は，本ウェブサイト上で提供するサービス（以下，「本サービス」といいます。）における，ユーザーの個人情報の取扱いについて，以下のとおりプライバシーポリシー（以下，「本ポリシー」といいます。）を定めます。</p>

                    <h3>第1条（個人情報）</h3>
                    <p>「個人情報」とは，個人情報保護法にいう「個人情報」を指すものとし，生存する個人に関する情報であって，当該情報に含まれる氏名，生年月日，住所，電話番号，連絡先その他の記述等により特定の個人を識別できる情報及び容貌，指紋，声紋にかかるデータ，及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。</p>

                    <h3>第2条（個人情報の収集方法）</h3>
                    <p>当社は，ユーザーが利用登録をする際に氏名，生年月日，住所，電話番号，メールアドレス，銀行口座番号，クレジットカード番号などの個人情報をお尋ねすることがあります。</p>

                    <p className="mt-8 text-sm text-gray-500">
                        ※ 実運用の際は、弁護士等の専門家に相談の上、詳細なポリシーを作成してください。
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPage;
